(function () {
    angular.module('tradersyard').service('graph-api-client', GraphApiClient);

    GraphApiClient.$inject = ['$http', 'WebSocket'];

    function GraphApiClient($http, $socket) {
        var self = this;

        self.version = 'v1.0';

        /**
         * Keeps other API clients. E.g. graph-meeting-factory
         * @type {{meeting: object}}
         */
        self.factory = {};

        /**
         * Builds API url when given path. If array is passed, the segments will be joined with "/".
         *
         * @param {string|string[]} path URL path or path segments as array.
         * @returns {string}
         */
        self.url = function (path) {
            var urlPath = Array.isArray(path) ? path.clean(undefined).join('/') : path;

            return ['/api/', self.version, '/', urlPath].join('');
        };

        self.get = function (url, options) {
            return $http.get(self.url(url), extendOptions(options));
        };

        /**
         *  @param  {String} url
         *  @param  {Object} data
         *  @param  {Object} options
         *
         *  @return {Function}
         */
        self.post = function (url, data, options) {
            return $http.post(self.url(url), data, extendOptions(options));
        };

        self.put = function (url, options) {
            return $http.put(self.url(url), extendOptions(options));
        };

        self.httpPut = function (url, data, options) {
            return $http.put(self.url(url), data, extendOptions(options));
        };

        self.delete = function (url, options) {
            return $http.delete(self.url(url), extendOptions(options));
        };

        /**
         *  Alias for {delete}
         */
        self.del = self.delete;

        function extendOptions(options) {
            if (options === undefined) {
                options = {};
            }

            if (options.hasOwnProperty('headers') === true) {
                options.headers['X-Socket-Id'] = $socket.getSocketId();
                return options;
            } else {
                options.headers = {
                    'X-Socket-Id': $socket.getSocketId(),
                };
                return options;
            }
        }
    }
})();
